// Homepage FAQ content — surfaced as visible accordion and FAQPage JSON-LD
// for Answer Engine Optimization (Google AI Overviews, ChatGPT, Perplexity).
export interface SiteFaq {
  question: string;
  answer: string;
}

export const HOME_FAQS: SiteFaq[] = [
  {
    question: "What are the biggest US lottery jackpots right now?",
    answer:
      "Powerball and Mega Millions consistently produce the largest US lottery jackpots, often rolling into the hundreds of millions of dollars. USA Lottery Club tracks live estimated jackpots, cash values, and next draw times for every major multi-state and state-run game in all 50 states. Check the Current Jackpots section above for the latest figures.",
  },
  {
    question: "When are Powerball and Mega Millions drawn?",
    answer:
      "Powerball is drawn Monday, Wednesday, and Saturday at 10:59 PM ET. Mega Millions is drawn Tuesday and Friday at 11:00 PM ET. Cash4Life is drawn every night at 9:00 PM ET. Ticket sales typically close 1–2 hours before the draw, and cut-off times vary by state.",
  },
  {
    question: "How do I check lottery winning numbers?",
    answer:
      "Use the Latest Results section on this page, the Results page for a complete history, or our free Results Checker tool to match your ticket numbers against recent draws across every US lottery game. Results are updated within minutes of each draw.",
  },
  {
    question: "How much will I take home if I win the lottery?",
    answer:
      "Lottery winnings are subject to a 24% federal tax withholding, with additional federal tax owed at filing (top bracket 37%). State taxes range from 0% (e.g. Florida, Texas, Tennessee) to over 10% (e.g. New York, New Jersey). Use the USA Lottery Club Tax Calculator to estimate your exact take-home for a lump-sum or annuity payout in your state.",
  },
  {
    question: "Lump sum or annuity — which is better?",
    answer:
      "The cash lump sum is typically 50–60% of the advertised jackpot but paid immediately. The annuity pays the full advertised amount in 30 graduated annual installments over 29 years. Lump sum gives investment flexibility; annuity offers long-term tax smoothing and protection from overspending. Most winners (over 95%) choose the lump sum.",
  },
  {
    question: "What are the odds of winning Powerball or Mega Millions?",
    answer:
      "The odds of winning the Powerball jackpot are 1 in 292,201,338. The odds of winning the Mega Millions jackpot are 1 in 290,472,336. Lower-tier prizes have much better odds — overall odds of winning any Powerball prize are about 1 in 24.9, and any Mega Millions prize about 1 in 24.",
  },
  {
    question: "Can I play state lottery games online?",
    answer:
      "Online lottery sales are available in select states including Pennsylvania, Michigan, Illinois, Kentucky, Georgia, North Carolina, Virginia, New Hampshire, and New Jersey. Other states require buying physical tickets at licensed retailers. Always play through your official state lottery website.",
  },
  {
    question: "How are lottery numbers generated for Quick Picks?",
    answer:
      "Lottery Quick Picks use a certified random number generator that selects numbers within the game's valid range. Our free Number Generator tool uses the same approach and supports both pure random and strategy-based picks (hot, cold, or balanced numbers) for every major US lottery game.",
  },
  {
    question: "What time do lottery results come out tonight?",
    answer:
      "Most US lottery draws take place between 6:00 PM and 11:00 PM local time. Powerball draws at 10:59 PM ET (Mon/Wed/Sat), Mega Millions at 11:00 PM ET (Tue/Fri), and Cash4Life at 9:00 PM ET nightly. State games such as Pick 3 and Pick 4 usually have both a midday and an evening draw. Winning numbers appear on USA Lottery Club within minutes of each official draw.",
  },
  {
    question: "How long do I have to claim a lottery prize?",
    answer:
      "Claim deadlines are set by each state and typically range from 90 days to one year from the draw date — for example 180 days in Texas and Florida, and one year in California and New York. Unclaimed prizes are returned to the state, usually funding education or public programs. Always check the expiry printed on your ticket and your state lottery's official rules.",
  },
  {
    question: "Can I stay anonymous if I win the lottery?",
    answer:
      "Some states allow winners to remain anonymous, including Delaware, Kansas, Maryland, North Dakota, Ohio, South Carolina, and Texas (for prizes of $1 million or more). Others require your name and city to be public record, though many permit claiming through a trust or LLC to add privacy. Consult a lawyer before claiming a large prize.",
  },
  {
    question: "What are the most frequently drawn lottery numbers?",
    answer:
      "Across recent Powerball draws, numbers such as 61, 32, 21, 63, and 36 have appeared most often, while Mega Millions frequently draws 17, 31, 10, 14, and 20. Every draw is independent and past frequency does not change the odds, but our free Frequency Analyzer shows hot and cold numbers for any game and date range.",
  },
  {
    question: "Which states have no lottery?",
    answer:
      "Five states do not run a lottery: Alabama, Alaska, Hawaii, Nevada, and Utah. Residents of those states can still legally buy tickets in a neighbouring state, and multi-state jackpots like Powerball and Mega Millions can be claimed regardless of where you live.",
  },
  {
    question: "Do lottery winnings affect my taxes in every state?",
    answer:
      "Federal tax applies everywhere, but state tax varies widely. California, Florida, Texas, Tennessee, South Dakota, Washington, Wyoming, and New Hampshire levy no state tax on lottery prizes, while New York (10.9%), New Jersey (10.75%), and Oregon (9.9%) are among the highest. Use the state-by-state Tax Calculator for an exact take-home estimate.",
  },
];